import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    managePriceText: {
      ...CommonFonts.darkBoldFont30,
      fontSize: 34,
      letterSpacing: 0.28,
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
    },
    updateButton: {
      height: 60,
      width: 200,
      "&.MuiButton-root": {
        textTransform: "none",
        fontSize: 18,
      },
    },
    searchInput: {
      backgroundColor: Colors.WHITE,
      "& input": {
        height: 60,
        fontSize: 24,
        padding: "0px 16px",
        color: Colors.GRAY_DARK,
      },
      "& fieldset": {
        borderWidth: 2,
        borderColor: Colors.GRAY_BORDER,
      },
      "& .MuiInputBase-root:hover fieldset": {
        borderColor: Colors.BLUE,
      },
    },
    linkButton: {
      height: 60,
      "&.MuiButton-root": {
        borderColor: Colors.GRAY_BORDER,
        borderWidth: 2,
        backgroundColor: Colors.WHITE,
        color: Colors.GRAY_DARK,
      },
      "&.MuiButton-root:hover": {
        borderColor: Colors.GRAY_BORDER,
        borderWidth: 2,
        backgroundColor: Colors.WHITE,
      },
    },
    downloadButton: {
      height: 60,
      "&.MuiButton-root": {
        borderColor: Colors.GRAY_BORDER,
        borderWidth: 2,
        backgroundColor: Colors.WHITE,
        textTransform: "none",
        color: Colors.GRAY_DARK,
        fontSize: 18,
      },
      "&.MuiButton-root:hover": {
        borderColor: Colors.GRAY_BORDER,
        borderWidth: 2,
        backgroundColor: Colors.WHITE,
      },
    },
    updateTimeText: {
      ...CommonFonts.darkBoldFont20,
    },
    lastUpdatedText: {
      ...CommonFonts.darkFont16,
      marginTop: 6,
    },
  })
);

export default useStyles;
